var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    staticClass: "root",
    class: {
      active: _vm.active
    }
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "d-block",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }